import { Navigate } from "react-router-dom";

import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  Timeline,
  ContentTimeline,
  DetailContentTimeline,
  ContentAnnouncement,
  DetailContentAnnouncement,
  ReadDetailAnnouncement,
  AddAnnouncement,
} from "./pages";

const timelineRoutes = [
  {
    path: "/timeline",
    element: (
      <ProtectedRoute name="timeline">
        <Timeline />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb name="timeline" defaultTitle="timeline.title" />
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/timeline/main" replace />,
      },
      {
        path: "/timeline/main",
        element: <ContentTimeline />,
        breadcrumb: null,
        children: [
          {
            path: "/timeline/main/:id",
            element: <DetailContentTimeline />,
            breadcrumb: null,
          },
        ],
      },
      {
        path: "/timeline/announcement",
        element: <ContentAnnouncement />,
        breadcrumb: () => (
          <TranslationBreadcrumb name={"timeline.announcement"} />
        ),
        children: [
          {
            path: "/timeline/announcement/:id",
            element: <DetailContentAnnouncement />,
            breadcrumb: null,
          },
          {
            path: "/timeline/announcement/read/:id",
            element: <ReadDetailAnnouncement />,
            breadcrumb: null,
          },
          {
            path: "/timeline/announcement/add",
            element: <AddAnnouncement />,
            breadcrumb: null,
          },
        ],
      },
    ],
  },
];

export default timelineRoutes;
